import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const WhoItsForSection = () => {
  const idealCustomers = [
    {
      id: 1,
      icon: 'Eye',
      title: 'Value Transparency',
      description: 'You want to know exactly what you\'re paying for — no hidden fees, no surprises'
    },
    {
      id: 2,
      icon: 'AlertCircle',
      title: 'Tired of Confusing Estimates',
      description: 'You\'ve received wildly different quotes and don\'t know who to trust'
    },
    {
      id: 3,
      icon: 'Award',
      title: 'Want Quality Without Inflation',
      description: 'You refuse to compromise on quality but won\'t pay inflated prices'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={containerVariants}
          className="space-y-16">
          
          {/* Header */}
          <motion.div variants={itemVariants} className="max-w-3xl mx-auto text-center space-y-6">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-jakarta font-bold text-[#000150] leading-[1.1]">
              Who OpenbooQ Is For
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              Smart homeowners who demand transparency, quality, and fair pricing.
            </p>
          </motion.div>

          {/* Ideal Customers Grid */}
          <motion.div 
            variants={containerVariants}
            className="grid md:grid-cols-3 gap-8">
            {idealCustomers?.map((customer) => (
              <motion.div
                key={customer?.id}
                variants={itemVariants}
                whileHover={{ scale: 1.05 }}
                className="bg-gradient-to-br from-cyan-50 to-blue-50 p-8 rounded-2xl border border-cyan-200 hover:shadow-xl transition-all duration-300">
                <div className="w-14 h-14 bg-cyan-500 rounded-xl flex items-center justify-center mb-6">
                  <Icon name={customer?.icon} size={28} className="text-white" />
                </div>
                <h3 className="text-xl font-jakarta font-bold text-[#000150] mb-3">
                  {customer?.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {customer?.description}
                </p>
              </motion.div>
            ))}
          </motion.div>

          {/* Bottom Statement */}
          <motion.div 
            variants={itemVariants}
            className="max-w-2xl mx-auto text-center">
            <p className="text-2xl font-jakarta font-semibold text-[#000150]">
              If this sounds like you, OpenbooQ was built for you.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhoItsForSection;